<script lang="ts">
  import { Chip, type FacetValue } from "../facet-value";
  import type { FacetValueGroup, FacetValueGroupOptions } from "./type";

  interface Props extends FacetValueGroup, FacetValueGroupOptions {
    wrap?: boolean;
    withExpander?: boolean;
    horizontalScroll?: boolean;
  }

  let {
    values = [],
    title,
    item = chip,
    containsRanges = false,
    valueStatus,
    wrap = false,
    withExpander = false,
    horizontalScroll = true,
  }: Props = $props();
</script>

{#snippet chip(facetValue: FacetValue)}
  <Chip {...facetValue} />
{/snippet}

{#if values.length > 0}
  <div class={["hc_facetValueGroup__container", valueStatus ? `hc_facetValueGroup--${valueStatus}` : ""]}>
    {#if title}<h4>{title}</h4>{/if}
    <ul
      class={["hc_facetValueGroup__list", { "hc_facetValueGroup--ranges": containsRanges }]}
      style="--flex-wrap: {wrap ? 'wrap' : 'nowrap'}; --overflow-box-bleed-block: {horizontalScroll
        ? 'calc(var(--oc-semantic-focus-outline-offset, 2px) + var(--oc-semantic-focus-outline-width, 2px))'
        : '0'}; {horizontalScroll ? 'overflow-x: auto' : ''}"
    >
      {#each values as facetValue (facetValue.id + facetValue.title)}
        <li class={["hc_facetValueGroup__item"]}>{@render item(facetValue)}</li>
      {/each}
      {#if withExpander}
        <li class="hc_facetValueGroup--showMore" hidden>
          <!-- eslint-disable-next-line svelte/valid-compile -->
          <oc-link-v2>Mehr Anzeigen</oc-link-v2>
        </li>
        <li class="hc_facetValueGroup--showLess" hidden>
          <!-- eslint-disable-next-line svelte/valid-compile -->
          <oc-link-v2>Weniger Anzeigen</oc-link-v2>
        </li>
      {/if}
    </ul>
  </div>
{/if}

<style lang="scss">
  h4 {
    margin-bottom: var(--oc-semantic-spacing-75);
    font: var(--oc-semantic-font-copy-75);
    text-transform: uppercase;
    color: var(--oc-semantic-color-text-secondary);
  }

  ul {
    overflow-y: hidden;
    display: flex;
    flex-wrap: var(--flex-wrap, nowrap);
    align-items: center;
    gap: var(--oc-semantic-spacing-50);

    /*                                                                 */
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    /*                       */
    /*                                                                                                      */
    /*                      */
    scrollbar-width: none;
    margin-block: calc(-1 * var(--overflow-box-bleed-block, 0));
    margin-inline: 0;
    padding-block: var(--overflow-box-bleed-block, 0);
    padding-inline: 0;

    li {
      flex-basis: max-content;
    }
  }

  .hc_facetValueGroup--ranges {
    margin-top: var(--oc-semantic-spacing-50);
    margin-bottom: calc(var(--oc-semantic-spacing-25) + var(--oc-semantic-spacing-75));
  }

  .hc_facetValueGroup__container:has(.hc_facetValueGroup--showMore) {
    width: 100%;
  }

  .hc_facetValueGroup__list {
    &--denseMode .hc_facetValueGroup--showMore {
      display: flex;
      margin-left: auto;
    }
  }
</style>
